<template>
  <div>
    <!-- Form -->
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>         

              <v-flex xs12 sm6 md6>              
                <v-autocomplete
                v-model="formSchema.finanacial_year"
                :items="BudgetingYearList"
                label="Finanacial Year"                         
                :rules="[v => !!v || 'Finanacial year is required !']"
                required
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-autocomplete
                label="Budget Category"
                v-model="formSchema.budget_category"
                :items="rootNameList"
                :rules="[v => !!v || 'Budget category is required !']"
                required
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <DatePicker
                  :key="formSchema.id"
                  :inputData="{index:1,fieldName:'year_from_date', fieldValue:formSchema.year_from_date, label:'From Date',required:1}"
                  @setValue="setDateValue"
                ></DatePicker>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <DatePicker
                  :key="formSchema.id"
                  :inputData="{index:1,fieldName:'year_to_date', fieldValue:formSchema.year_to_date, label:'To Date',required:1,disabled:'1'}"
                  ref="setRange"
                  @setValue="setDateValue"
                ></DatePicker>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                  label="Related Document"
                  v-model="formSchema.document_name"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                File
                <input
                  type="file"
                  id="files2"
                  ref="image2"
                  v-on:change="handleFilesUpload()"
                />
              </v-flex>

               <v-flex xs12 sm6 md6 >
                <v-checkbox v-model="formSchema.is_active" label="Active" :value="is_activeVal"></v-checkbox>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click.native="validateBeforeSubmit" :disabled="!valid">
            <v-icon>save</v-icon>
            {{addUpdateBtn}}
          </v-btn>
          <v-btn color="error" @click.native="$refs.form.reset" @click="resetForm">
            <v-icon>refresh</v-icon>Reset
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../services/common.service");
let utilities = require("../../../utilities/utilities");
import DatePicker from "../../global/date_picker";
import ServerPath from "../../../server-path/server-path";

export default {
  props: ["formSchema"],
  components: {
    DatePicker
  },
  data: () => ({
    valid: true,
    is_activeVal:1,
    documentFiles: [],
    BudgetingYearList: utilities.getBudgetingYearList(),
    rootNameList: utilities.getRootNameList(),
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0 ? "Edit Mid Term Budget Framework(MTBF)" : "Add Mid Term Budget Framework(MTBF)";
    },
    addUpdateBtn() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    }
  },

  created() {
  },

  methods: {
    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;

      if(data.fieldName == "year_from_date"){
        this.formSchema.year_to_date = 0
        this.$refs.setRange.setRange(data.value);
      }
    },

    validateBeforeSubmit(e) {
      if (this.$refs.form.validate()) {
        this.submitForm();
      }
    },

    submitForm() {

      let formData = new FormData();
      var formSchema = this.formSchema;

      /*if (
        this.documentFiles.length == 0 &&
        this.formSchema.upload_file_name == ""
      ) {
        this.close({ message: "You don't select any file!", status: 0 });
        return false;
      }*/

      formSchema.year_from_date = this.changeFormateYMD(
        this.formSchema.year_from_date
      );
      formSchema.year_to_date = this.changeFormateYMD(
        this.formSchema.year_to_date
      );

      for (var i = 0; i < this.documentFiles.length; i++) {
        let file = this.documentFiles[i];
        formData.append("files[" + i + "]", file);
      }
      
      formSchema.record_id = sessionStorage.getItem("mm_id");
      formSchema.sub_menu_id = sessionStorage.getItem("sm_id");

      formData.append("fieldValues", JSON.stringify(formSchema));

      commonService.insertFormData(formData, "mid-term-budget-framework").then(res => {
        let actionData = {
          message: res.message,
          data: res.data,
          action: res.action,
          status: res.status
        };
        if (res.status == 1) {
          this.documentFiles = [];
          document.getElementById("files2").value = null;
          this.formSchema.id = 0;
          this.$refs.form.reset();
          this.formSchema.year_from_date = ''      
          this.formSchema.year_to_date = '';
        }
        this.close(actionData);
      });
    },

    handleFilesUpload() {
      let uploadedFiles = this.$refs.image2.files;
      let fileExtension = uploadedFiles[0].name.replace(/^.*\./, "");
      //console.log("uploadedFiles", uploadedFiles);

      let allowedExtensions = /(\.jpg|\.JPG|\.jpeg|\.JPEG|\.png|\.PNG|\.pdf|\.doc|\.docx)$/i;
      if (!allowedExtensions.exec(uploadedFiles[0].name)) {
        this.message = "You can upload jpg, jpeg, png, pdf, doc and docx file only";
        this.snackbar = true;
        this.$refs.image2.value = "";
        this.documentFiles = [];
      } else {
        for (var i = 0; i < uploadedFiles.length; i++) {
          this.documentFiles.push(uploadedFiles[i]);
        }
      }
    },

    resetForm(){
      this.formSchema.id = 0;      
    },

    close: function(data) {
      this.$emit("emitForm", data);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/project_info/mid_term_project_budget/insertForm.vue